<template>
  <main class="cabinet-page">
    <div
      class="cabinet-page__body"
      v-if="isShowList">
      <router-link
        v-bind:to="{ name: 'ClinicPanelSettings' }"
        class="cabinet-page__button-back"
      >
        Назад
      </router-link>
      <div class="cabinet-page__body__row">
        <h1 class="cabinet-page__title">
          <span>
            Кресла
          </span>
          <button
            type="button"
            v-on:click="showHintDialog = true"
          >
            ? Как настроить
          </button>
        </h1>
        <next-step-setting-instruction
          v-bind:current-route-name="$route.name"
          v-bind:available-steps="instructionSteps"
        >
          <button
            id="cabinet-button-create-parent"
            class="cabinet-page__button"
            type="button"
            v-show="hasCreateCabinet"
            v-on:click="openFormCreationCabinet(); uploadShowsUser('cabinet-button-create');">
            Новое кресло
          </button>
        </next-step-setting-instruction>
      </div>
      <cabinet-table
        v-if="isNotEmptyList"
        v-bind:actions="actions"
        v-bind:cabinetList="cabinetList"
        v-on:delete-cabinet="onDeleteCabinet"
        v-on:edit-cabinet="setEditCabinet" />
      <div
        v-else
        class="cabinet-page__body__empty">
        <h3>В этом разделе будет храниться перечень кресел вашей клиники.<br>
          Пока вы не добавили ни одного кресла.</h3>
        <button
          class="cabinet-page__body__empty__button"
          type="button"
          v-on:click="openFormCreationCabinet">
          Добавить
        </button>
      </div>
    </div>
    <side-slide-transition>
      <confirm-side-dialog
        v-bind:label="formTitle"
        v-bind:need-confirm="needConfirmBeforeCloseForm"
        v-if="showCabinetForm"
        v-on:cancel="closeCabinetForm">
        <form-cabinet
          ref="formCabinet"
          v-bind:cabinet="cabinet"
          v-bind:input-errors="cabinetInputErrors"
          v-on:change-values="onChangeFieldValues"
          v-on:close="closeCabinetForm"
          v-on:submit-creating="onCreateCabinet"
          v-on:submit-editing="onEditCabinet" />
      </confirm-side-dialog>
    </side-slide-transition>
    <confirm-side-dialog
      label="Как создать кресло"
      v-if="showHintDialog"
      v-on:cancel="showHintDialog = false"
      class="cabinet-page__modal"
    >
      <br>
      <p>
        Кресла нужны для удобного формирования расписания.
      </p>
      <zoom-image
        class="cabinet-page__modal__img"
        v-bind:src="require('@/assets/img/help/new/92.png')"
        imageWidth="586"
        imageHeight="288"
        alt="Создание кресла"
      />
      <ol>
        <b>Нажмите на кнопку  «+ Новое кресло» и укажите:</b>
        <li>
          Название кресла (Пример: 102 кресло; Кресло осмотра).
        </li>
        <li>
          Примечание для кресла (Пример: кресло для осмотра пациентов).
        </li>
        <li>
          Выберите цвет иконки кресла.
        </li>
      </ol>
      <p>
        Нажмите кнопку «Создать».
      </p>
    </confirm-side-dialog>
    <on-boarding-dialog
      :is-page-ready="isReadyToOnBoarding"
      :is-show-button-create-cabinet="isShowButtonCreateCabinet"
      :is-show-button-next-cabinet="isShowButtonNextCabinet"
      @showed="showedOnboarding"
    >
      <button
        v-if="isShowButtonCreateCabinet"
        id="cabinet-button-create-child"
        class="cabinet-page__button"
        disabled
        type="button">
        Новое кресло
      </button>
      <a
        id="settings-button-next-child"
        v-if="isShowButtonNextCabinet"
        disabled="1"
        class="cabinet-page__button-child"
      >
        Далее
      </a>
    </on-boarding-dialog>
  </main>
</template>

<script>
import {
  List,
} from 'monet';
import CabinetTable from '@/components/CabinetTable.vue';
import { builtInDialogMixin, DialogResult } from '@/components/ClinicPanelDialog.vue';
import FormCabinet from '@/components/FormCabinet.vue';
import SideSlideTransition from '@/components/SideSlideTransition.vue';
import cabinetViewMixin from '@/mixins/cabinetViewMixin';
import focusMixin from '@/mixins/focusMixin';
import notifierMixin from '@/mixins/notifierMixin';
import ConfirmSideDialog from '@/components/ConfirmSideDialog.vue';
import settingInstructionMixin from '@/mixins/settingInstructionMixin';
import NextStepSettingInstruction from '@/components/NextStepSettingInstruction.vue';
import ZoomImage from '@/components/ZoomImage.vue';
import onBoardingMixin from '@/mixins/onBoardingMixin';
import OnBoardingDialog from '@/components/OnBoardingDialog.vue';
import onBoardingShowMixin from '@/mixins/onBoardingShowMixin';

/**
 * @description Страница кабинетов клиники.
 * @type {any}
 */
export default {
  components: {
    OnBoardingDialog,
    ZoomImage,
    NextStepSettingInstruction,
    CabinetTable,
    FormCabinet,
    SideSlideTransition,
    ConfirmSideDialog,
  },
  computed: {
    /**
     * Готова ли страница к показу ОнБординга
     *
     * @return {boolean}
     */
    isReadyToOnBoarding() {
      return this.hasCreateCabinet;
    },
    /**
     * Показываем представление "Создать роль"
     *
     * @return {boolean}
     */
    isShowButtonCreateCabinet() {
      return this.step?.notShowedView === 'cabinet-button-create';
    },
    /**
     * Показываем представление "далее"
     *
     * @return {boolean}
     */
    isShowButtonNextCabinet() {
      return this.step?.notShowedView === 'cabinet-button-next';
    },
    formTitle: ({ isEdit }) => (isEdit ? 'Редактирование кресла' : 'Новое кресло'),
    hasCreateCabinet() {
      return this.actions.includes('add');
    },
    isEdit: ({ cabinet }) => !!cabinet,
    isShowList: ({ isAwaitLoadCabinetList, isNotEmptyList }) => (
      !isAwaitLoadCabinetList || isNotEmptyList
    ),
    isNotEmptyList: ({ cabinetList }) => cabinetList.size() > 0,
  },
  async created() {
    this.fetchInstructionSteps();
    await this.reloadCabinetList();
    if (this.$route.params.id) {
      this.setEditCabinet(this.$route.params.id);
    }
  },
  updated() {
    this.definePositionAndSetPositionsToChildComponent(
      this.isShowButtonCreateCabinet,
      '#cabinet-button-create-parent',
      '#cabinet-button-create-child',
    );
    this.definePositionAndSetPositionsToChildComponent(
      this.isShowButtonNextCabinet,
      '#settings-button-next-parent',
      '#settings-button-next-child',
    );
  },
  data() {
    return {
      /**
       * @description Допустимые действия.
       * @type {string[]}
       */
      actions: [],
      /**
       * @description Список кабинетов.
       * @type {List<Cabinet>}
       */
      cabinetList: List(),
      /**
       * Ожидание загрузки списка кабинетов.
       * @type {boolean}
       */
      isAwaitLoadCabinetList: false,
      /**
       * @description Показывать форму для работы с кабинетом.
       * @type {boolean}
       */
      showCabinetForm: false,
      /**
       * @description Необходимо подтверждение перед закрытием формы.
       * @type {boolean}
       */
      needConfirmBeforeCloseForm: false,
      /**
       * @description Показывать диалоговое окно подсказки.
       * @type {boolean}
       */
      showHintDialog: false,
      /**
       * Слаг шага ОнБординга
       * @type {string}
       */
      stepSlug: 'create-addition-place',
    };
  },
  methods: {
    /**
     * @description Перезагрузить список кабинетов.
     * @returns {void}
     */
    reloadCabinetList() {
      const onResponse = (result) => {
        result.forEach(({ actions, cabinets }) => {
          this.actions = actions;
          this.cabinetList = List.fromArray(cabinets);
        });
        const { title, body } = result.val.onBoardingStatus;
        this.checkAndUpdate(title, body);
      };
      this.isAwaitLoadCabinetList = true;
      this
        .$cabinetGateway
        .getAll()
        .then(onResponse)
        .finally(() => { this.isAwaitLoadCabinetList = false; });
    },
    /**
     * @description Закрыть форму для работы с кабинетом.
     */
    closeCabinetForm() {
      this.showCabinetForm = false;
    },
    /**
     * @description Обработать создание кабинета.
     * @param {any} request Запрос.
     * @param {File|null}
     * @returns {any}
     */
    onCreateCabinet(request) {
      const onFail = ({
        interaction, leftResponse, detail, telegramLink, whatsAppLink,
      }) => {
        this.cabinetInputErrors = leftResponse.allCauses();
        if (!leftResponse.hasCauses()) {
          this.clarifyAndNotifyFail(interaction)(
            leftResponse.getTitle(),
            detail,
            telegramLink,
            whatsAppLink,
          );
        }
      };
      const onSuccess = (response) => {
        this.cabinet = null;
        this.closeCabinetForm();
        this.notifySuccess(response.message);
        this.reloadCabinetList();
      };
      this.$cabinetGateway
        .sendCreateCabinet(request)
        .then((result) => result.fold(onFail, onSuccess));
    },
    /**
     * @description Обработать изменения значимых полей формы.
     * @param {string}  name      Название формы.
     * @param {boolean} isChanged Есть изменения.
     * @returns {void}
     */
    onChangeFieldValues(name, isChanged) {
      this.needConfirmBeforeCloseForm = isChanged;
    },
    /**
     * @description Обработать удаление кабинета.
     * @param {number} id Идентификатор кабинета.
     * @returns {void}
     */
    async onDeleteCabinet(id) {
      const dialog = await this.showRemoveDialog('Вы действительно хотите удалить кресло?');
      if (dialog.result !== DialogResult.DELETE) {
        return;
      }
      const either = await this.$cabinetGateway.sendDeleteCabinet(id);
      either.fold(
        ({ title }) => {
          this.notifyFail(title);
        },
        (response) => {
          this.cabinetInputErrors = {};
          this.cabinet = null;
          this.notifySuccess(response.message);
          this.cabinetList = this.cabinetList.filter(
            (cabinet) => cabinet.id !== response.cabinetId,
          );
        },
      );
    },
    /**
     * @description Обработать редактирование кабинета.
     * @param {CabinetEditingRequest} request Запрос.
     * @returns {void}
     */
    onEditCabinet(request) {
      const onResponse = (result) => {
        result.forEach((response) => {
          this.cabinet = null;
          this.closeCabinetForm();
          this.notifySuccess(response.message);
          this.reloadCabinetList();
        });
      };
      this.sendEditCabinetRequest(request).then(onResponse);
    },
    /**
     * @description Открыть форму создания кабинета.
     * @returns {void}
     */
    openFormCreationCabinet() {
      this.cabinetInputErrors = {};
      this.cabinet = null;
      this.showCabinetForm = true;
      this.$nextTick(() => {
        this.focusIn(this.$refs.formCabinet.$el);
      });
    },
    /**
     * @description Установить кабинет для редактирования.
     * @param {number} id Идентификатор кабинета.
     * @returns {void}
     */
    setEditCabinet(id) {
      this
        .cabinetList
        .find((cabinet) => cabinet.id === id)
        .forEach((cabinet) => {
          this.cabinet = cabinet;
          this.cabinetInputErrors = {};
          this.showCabinetForm = true;
          this.$nextTick(() => {
            this.focusIn(this.$refs.formCabinet.$el);
          });
        });
    },
  },
  mixins: [
    onBoardingShowMixin,
    onBoardingMixin,
    builtInDialogMixin,
    cabinetViewMixin,
    focusMixin,
    notifierMixin,
    settingInstructionMixin,
  ],
  name: 'ClinicPanelCabinetList',
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";
.cabinet {
  &-page {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    &__body {
      padding: 38px 20px 48px 23px;
      width: 100%;
      overflow-y: scroll;
      &__empty {
        margin: 20px auto;
        max-width: 630px;
        text-align: center;
        &__button {
          margin: 20px auto;
          padding: 0 12px;
          @include buttons.btn-blue(fit-content(), 48px, 16px);
        }
      }
      &__row {
        display: flex;
        flex-flow: row wrap;
        gap: 10px;
        align-items: center;
        justify-content: space-between;
      }
    }
    &__title {
      display: flex;
      flex-flow: row wrap;
      align-items: baseline;
      gap: 10px 30px;
      button {
        font-size: 18px;
        font-weight: 500;
        color: #90a0b7;
        &:hover {
          color: #0489E0;
        }
      }
    }
    &__button-back {
      color: var(--action-color);
      display: flex;
      align-items: center;
      gap: 7px;
      width: fit-content;
      text-decoration: none;
      &:before {
        content: '';
        background-image: url('@/assets/img/arrow/arrow-blue.svg');
        background-position: center;
        background-size: contain;
        width: 12px;
        height: 12px;
        display: block;
      }
      &:hover {
        text-decoration: underline;
      }
    }
    &__button {
      @include buttons.btn-blue(250px, 48px, 16px);
      @include buttons.btn-blue-add(19px);
    }
    &__button-child {
      @include buttons.btn-blue(162px, 32px, 16px);
      text-decoration: none;
      color: #FFFFFF !important;
    }
    &__modal {
      &__img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
        margin: 15px 0;
      }
    }
  }
}
.validate-error {
  padding: 3px;
  color: red;
  font-size: 0.8rem;
}
@media screen and (max-width: 640px) {
  .cabinet-page {
    &__body {
      padding: 38px 10px 140px;
    }
  }
}

</style>
